/**
 * @generated SignedSource<<89682af8e467e2c6ec4f918ebb0625ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type WidgetNoteEditingMode = "DEFAULT" | "READ_ONLY";
import { FragmentRefs } from "relay-runtime";
export type NoteNative_note$data = {
  readonly editingMode: WidgetNoteEditingMode;
  readonly id: string;
  readonly isOrgNote: boolean;
  readonly pages: ReadonlyArray<{
    readonly backgroundColor: string | null;
    readonly fontColor: string | null;
    readonly id: string;
    readonly image: {
      readonly id: string;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetNotePage_widgetNotePage">;
  }>;
  readonly title: string;
  readonly " $fragmentType": "NoteNative_note";
};
export type NoteNative_note$key = {
  readonly " $data"?: NoteNative_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"NoteNative_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NoteNative_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "editingMode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrgNote",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetNotePage",
      "kind": "LinkedField",
      "name": "pages",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "image",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fontColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "backgroundColor",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetNotePage_widgetNotePage"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "27a3444bb059a9e1bae2ef1fc0f6d1d0";

export default node;
